import { useCallback, useState } from 'react';

import useDynamicLogEvents from 'src/hooks/useDynamicLogEvents';
import { AnalyticsEvent, EventParamKeys, Methods } from 'src/utils/analytics';

export interface ModalProps {
    onClose: () => void;
    open: boolean;
}

export default function useModalOpenState(initialOpened?: boolean, onOpen?: () => void) {
    const [opened, setOpened] = useState(Boolean(initialOpened));

    const open = useCallback(() => {
        setOpened(true);
        onOpen?.();
    }, [setOpened, onOpen]);

    const close = useCallback(() => {
        setOpened(false);
    }, [setOpened]);

    return { props: { open: opened, onClose: close } as ModalProps, open };
}

export const useShareViaModal = (initialOpened?: boolean) => {
    const { logEventDynamic } = useDynamicLogEvents();
    return useModalOpenState(initialOpened, () => {
        logEventDynamic(AnalyticsEvent.ShareVia);
    });
};

export const useShareAsPrivateMessageModal = (initialOpened?: boolean) => {
    const { logEventDynamic } = useDynamicLogEvents();
    return useModalOpenState(initialOpened, () => {
        logEventDynamic(AnalyticsEvent.ShareViaPrivateMessage, {
            [EventParamKeys.Method]: Methods.Message,
        });
    });
};
